import { ArrowRight, CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";

export const Hero = () => {
  const navigate = useNavigate();

  return (
    <section id="home" className="relative min-h-screen flex items-center bg-gray-50 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative w-full pt-36 pb-20 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-block">
              <span className="bg-crimson-100 text-crimson-600 px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-semibold whitespace-nowrap">
                Family-Owned Since 2015
              </span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Transform Your Home with{" "}
              <span className="text-crimson-600">Expert Craftsmanship</span>
            </h1>
            
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
              Trusted remodeling services in Central Virginia. From kitchen renovations to complete home additions, 
              we bring your vision to life with quality work, honest pricing, and dependable service.
            </p>

            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <CheckCircle className="w-6 h-6 text-crimson-600 flex-shrink-0" />
                <span className="text-gray-700 font-medium">Family-Owned & Operated</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle className="w-6 h-6 text-crimson-600 flex-shrink-0" />
                <span className="text-gray-700 font-medium">Quality Materials & Expert Craftsmanship</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle className="w-6 h-6 text-crimson-600 flex-shrink-0" />
                <span className="text-gray-700 font-medium">Serving Central Virginia Since 2015</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button 
                onClick={() => navigate("/contact")}
                size="lg" 
                className="bg-crimson-600 hover:bg-crimson-700 text-white text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all"
              >
                Get Free Quote
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
              <Button 
                onClick={() => navigate("/services")}
                size="lg" 
                variant="outline" 
                className="border-2 border-gray-300 hover:border-crimson-600 text-gray-700 hover:text-crimson-600 text-lg px-8 py-6 transition-all"
              >
                View Services
              </Button>
            </div>
          </div>

          {/* Right Content - Hero Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://hernandezremodelingllcvirginia.com/wp-content/uploads/2025/10/IMG-20251004-WA0069.jpg" 
                alt="Quality Remodeling Work" 
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            </div>
            
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl">
              <div className="text-center">
                <p className="text-4xl font-bold text-crimson-600">10+</p>
                <p className="text-sm text-gray-600 font-medium">Years Experience</p>
              </div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -top-6 -right-6 bg-crimson-600 text-white p-6 rounded-xl shadow-xl">
              <div className="text-center">
                <p className="text-4xl font-bold">500+</p>
                <p className="text-sm font-medium">Projects Completed</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
